// extracted by mini-css-extract-plugin
export default {"DeclarationFormSwitch":"styles_DeclarationFormSwitch__L2W-J","DeclarationFormSwitchContainer":"styles_DeclarationFormSwitchContainer__+D-uc"};